<mat-toolbar><img style="width: 48px;" src="../../assets/logo.png" />
    <p> Project Tunton </p>
</mat-toolbar>


<mat-drawer-container class="example-container">
    <mat-drawer mode="side" opened>

        <div class="contents">




            <a (click)="showTracer()">
                <span class="material-icons mt-2" style="font-size: 30px;">
                    language
                </span>
                <p> Tracer </p>
            </a>

        </div>




    </mat-drawer>
    <mat-drawer-content>

        <div id="dash" [hidden]="isHiddenDash">

            <div class="container-fluid ">
                <div class="row">
                    <div class="col-md-4 leftSection p-5">
                        <p>Home </p>

                        <img [src]="placeImage" style="width: 250px; height: 250px;">


                    </div>
                    <div class="col-md-8 rightSection">

                    </div>
                </div>
            </div>


        </div>


        <div id="trace" [hidden]="isHiddenTrace">

            <div class="container-fluid ">
                <div class="row">
                    <div class="col-md-4 leftSection p-5">
                        <p>Search user</p>

                        <div [formGroup]="searchFormGroup">

                            <input type="text" class="formName" name="controlNO" formControlName="controlNO" required>
                            <br>
                            <br>
                            <button class="btn  btn-primary btn-block" (click)="searchUser(searchFormGroup.value)">
                                Search </button>
                        </div>

                        <br>
                        <p class="desc"> Input the quarantine pass Control number of a person you would like to trace.
                        </p>

                        <p> Mock data to search </p>
                        <ul>
                            <li>
                                CA-7642-828
                            </li>
                            <li>
                                CA-5069-430
                            </li>
                            <li>
                                CA-1682-476
                            </li>
                            <li>
                                CA-8225-630
                            </li>
                            <li>
                                CA-3132-709
                            </li>
                        </ul>

                        <p>Note all these are generated randomly but some data like medical conditions are based on
                            resources. <br />
                            for prototyping purpose only. </p>




                        <!--
                        <button class="btn btn-md btn-primary" (click)="populateMockData()"> Add Mock Data </button>
 -->


                    </div>
                    <div class="col-md-8 rightSection">



                        <div *ngIf="people$ | async; else noUser">



                            <div *ngFor="let people of people$ | async">



                                <div class="container-fluid m-2">

                                    <div class="row">
                                        <div class="col-md-6">
                                            <h1 class="display-4" style="font-size: 1.5rem;"> <strong
                                                    style="font-size: 1.0rem;"> Name </strong> <br> {{people.name}}
                                            </h1>
                                        </div>
                                        <div class="col-md-3">
                                            <h1 class="display-4 " style="font-size: 1.5rem;"> <strong
                                                    style="font-size: 1.0rem;"> Age </strong> <br> {{people.age}} </h1>
                                        </div>
                                        <div class="col-md-3">
                                            <h1 class="display-4 " style="font-size: 1.5rem;"> <strong
                                                    style="font-size: 1.0rem;"> Sex </strong> <br> {{people.gender}}
                                            </h1>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <h1 class="display-4" style="font-size: 1.5rem;"> <strong
                                                    style="font-size: 1.0rem;"> Control No </strong> <br>
                                                {{people.controlNo}} </h1>
                                        </div>

                                        <div class="col-md-3">
                                            <h1 class="display-4" style="font-size: 1.5rem;"> <strong
                                                    style="font-size: 1.0rem;"> Address </strong> <br>
                                                {{people.address}} </h1>
                                        </div>

                                        <div class="col-md-3">
                                            <h1 class="display-4" style="font-size: 1.5rem;"> <strong
                                                    style="font-size: 1.0rem;"> Contact </strong> <br>
                                                {{people.contact}} </h1>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <h1 class="display-4" style="font-size: 1.5rem;"> <strong
                                                    style="font-size: 1.0rem;"> Medrical Conditions </strong> <br>
                                                {{people.medicalCondition[0]}} </h1>
                                        </div>




                                    </div>

                                    <hr>




                                </div>


                            </div>

                            <div class="container-fluid m-2">


                                <h4> Recent Action </h4>
                                <div *ngFor="let action of action$ | async">

                                    <div class="m3">
                                        <div class="vertical-center">
                                            <div class="container">



                                                <div class="row">
                                                    <div class="col-md-8">
                                                        <h1> {{action.place}}</h1>


                                                        <p> {{action.timein2}} - {{action.timeout2}} </p>

                                                        <p *[(ngModel)]="prop"></p>

                                                        <div class="container ">
                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <div class="graph">
                                                                        <div id="bartwo" ng-style="{ 'width' : 80% }">
                                                                        </div>
                                                                        <div id="barone"></div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>

                                                    <div class="col-md-4">
                                                        <p> {{ possibleCount }} peson(s) Vulnerable </p>
                                                        <button class="btn btn-md btn-primary" (click)="openProfileDialog()"> Show details </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <br />


                                </div>

                            </div>






                        </div>


                        <ng-template #noUser>
                            <div class="text-center">


                                <p> Your information here </p>
                            </div>
                        </ng-template>

                    </div>
                </div>
            </div>


        </div>





    </mat-drawer-content>
</mat-drawer-container>